<script lang="ts">
	import { fly } from 'svelte/transition';
	import Section from '../organizational/Section.svelte';
	import { KTIForm } from '../form';
	import type { SectionAll } from '$lib/config';
	import { onMount } from 'svelte';

	export let sections: SectionAll[] = [];
	let currentStep = 0;
	let steps: { [key: number]: HTMLLIElement } = {};
	let currentSection: any;
	let stepperEl: HTMLUListElement;
	let stepperHeaderEls: { [key: number]: HTMLDivElement } = [];
	let direction = 'left';
	$: flyX = direction === 'left' ? 200 : -200;
	let validSteps: boolean[] = [];
	onMount(() => {
		validSteps = Array(sections.length).fill(false);
		console.log(KTIForm.form_config);
		currentSection = sections[0];
		setTimeout(updateSectionHeight, 100);
	});

	function handleSwipe(node: any) {
		// const hammer = new Hammer(node);
		// hammer.on('swipeleft swiperight', (e) => {
		// 	let direction = e.type === 'swipeleft' ? 'left' : 'right';
		// 	if (direction == 'left') {
		// 		if (currentStep < sections.length - 1) setStep(currentStep + 1);
		// 	} else if (direction == 'right') {
		// 		if (currentStep > 0) setStep(currentStep - 1);
		// 	}
		// });
	}

	function updateSectionHeight() {
		if (stepperEl) {
			let stepHeaderHeight = stepperHeaderEls[currentStep].clientHeight;
			stepperEl.style.height = currentSection.contentEl.clientHeight + stepHeaderHeight + 'px';
			//console.log('stepHeaderHeight:', stepHeaderHeight, currentSection.contentEl.clientHeight);
		}
		setTimeout(updateSectionHeight, 100);
	}

	async function setStep(targetStepIndex: number) {
		let numSections = sections.length;
		// Prevent invalid target step or switching to the same step.
		if (targetStepIndex >= numSections) {
			targetStepIndex = numSections - 1;
		}
		if (targetStepIndex < 0 || targetStepIndex === currentStep) {
			return;
		}

		//Backward navigation
		let goingBack = targetStepIndex < currentStep;
		direction = goingBack ? 'right' : 'left';
		if (goingBack) {
			//Invalidate the target step
			validSteps[targetStepIndex] = false;

			//Hide current section
			currentSection.contentEl.style.display = 'none';
			//console.log('flyX:', flyX);
			// fly(currentSection.contentEl, {
			// 	x: flyX,
			// 	duration: 200,
			// 	easing: (t) => t
			// });
			//Unhide target section
			currentSection = sections[targetStepIndex];
			currentSection.contentEl.style.display = '';
			// fly(currentSection.contentEl, {
			// 	x: -flyX,
			// 	duration: 200,
			// 	easing: (t) => t
			// });
			currentStep = targetStepIndex;
			//scroll to the top
			window.scrollTo(0, 0);
			return;
		}

		// For forward navigation:
		// Validate the current step (use stored validSteps flag if available).
		let invalidSection = await KTIForm.isSectionValid(currentSection);
		let isCurrentStepValid = invalidSection === true;
		if (!isCurrentStepValid) {
			steps[currentStep].classList.add('stepper-invalid');
			if (currentSection.ValidationRequired) {
				KTIForm.error_modal.Show('Please fill out all required fields before continuing.');
				// focus first invalid field (assuming invalidSection is set appropriately)
				invalidSection.Comp.focus();
				return;
			}
		} else {
			//Don't skip invalid steps
			// Mark the current step as valid if it is not already.
			validSteps[currentStep] = true;

			steps[currentStep].classList.remove('stepper-invalid');
			steps[currentStep].classList.add('stepper-completed');
			//Check if all steps leading up to the target step are validated
			for (let i = currentStep + 1; i < targetStepIndex; i++) {
				//Switch to first invalid step, if found
				let isStepValid = validSteps[i] || (await KTIForm.isSectionValid(sections[i])) === true;
				if (isStepValid === false) {
					console.log('currentStep:', currentStep, 'i:', i, 'targetStepIndex:', targetStepIndex);
					steps[i].classList.add('stepper-invalid');
					steps[i].classList.remove('stepper-completed');
					steps[i].classList.add('stepper-active');
					steps[currentStep].classList.remove('stepper-active');

					currentSection.contentEl.style.display = 'none';
					//Unhide target section
					currentSection = sections[i];
					currentSection.contentEl.style.display = '';
					currentStep = i;
					//scroll to the top
					window.scrollTo(0, 0);

					//Get target steps section title
					let invalidSectionTitle = sections[i].Title;
					if (invalidSectionTitle) {
						KTIForm.error_modal.Show(
							`Please fill out all required '${invalidSectionTitle}' fields before continuing.`
						);
					} else {
						KTIForm.error_modal.Show(
							`There are required fields in a previous section need to be filled out first.`
						);
					}
					return;
				} else {
					steps[i].classList.remove('stepper-invalid');
					steps[i].classList.add('stepper-completed');
				}
			}
		}

		//Switch to target step
		steps[currentStep].classList.remove('stepper-active');
		steps[targetStepIndex].classList.remove('stepper-completed');
		steps[targetStepIndex].classList.add('stepper-active');

		//Hide current section
		currentSection.contentEl.style.display = 'none';
		// console.log('flyX:', flyX);
		// fly(currentSection.contentEl, {
		// 	x: flyX,
		// 	duration: 200,
		// 	easing: (t) => t
		// });
		//Unhide target section
		currentSection = sections[targetStepIndex];
		currentSection.contentEl.style.display = '';
		// fly(currentSection.contentEl, {
		// 	x: -flyX,
		// 	duration: 200,
		// 	easing: (t) => t
		// });
		currentStep = targetStepIndex;
		//scroll to the top
		window.scrollTo(0, 0);
	}
</script>

<ul class="stepper stepper-horizontal" bind:this={stepperEl} style="height: 2000px" use:handleSwipe>
	{#each sections as section, i}
		<li
			class:stepper-active={i === currentStep}
			class="stepper-step"
			class:stepper-competed={i < currentStep}
			bind:this={steps[i]}
			data-step_number={i}
		>
			<div
				class="stepper-head"
				on:click|preventDefault={() => setStep(i)}
				on:keydown={(e) => e.key === 'Enter' && setStep(i)}
				aria-roledescription="tab"
				bind:this={stepperHeaderEls[i]}
				role="tab"
				tabindex={0}
			>
				<span class="stepper-head-icon">
					{#if i < currentStep}
						<i class="fas fa-check" />
					{:else}
						{i + 1}
					{/if}
				</span>
				<span class="stepper-head-text">{section?.Title ?? `Step ${i + 1}`}</span>
			</div>

			<div
				class="stepper-content py-3"
				style="display: {i === currentStep ? 'block' : 'none'};"
				bind:this={section.contentEl}
			>
				<Section
					bind:section
					SectionType="Stepper"
					StepNumber={i}
					TotalSteps={sections.length}
					LastSection={i == sections.length - 1}
				/>

				<div class="d-flex justify-content-between" style="padding-left: 30px; padding-right: 30px">
					<div class="p-2">
						{#if currentStep > 0 && section.CanGoBack}
							<button
								on:click|preventDefault={() => setStep(currentStep - 1)}
								class="btn btn-primary">Back</button
							>
						{/if}
					</div>
					<div class="p-2">
						{#if currentStep < sections.length - 1}
							<button
								on:click|preventDefault={() => setStep(currentStep + 1)}
								class="btn btn-primary">Next</button
							>
						{/if}
					</div>
				</div>
			</div>
		</li>
	{/each}
</ul>
